module.exports = __webpack_public_path__ + "img/c2.f7fb4b70.png";